import { badgePropType } from 'constants';

import React from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';
import { Popover } from '@nextiva/next-ui-components';
import { defaultAnchorOrigin, defaultTransformOrigin } from '../../constants/popoverConfig';

import './HeaderIcon.scss';

class HeaderIcon extends React.Component {
  static propTypes = {
    blockName: PropTypes.string,
    className: PropTypes.string,
    customIconClass: PropTypes.string,
    popoverBody: PropTypes.node,
    isPopoverOpen: PropTypes.bool,
    icon: PropTypes.any,
    iconRenderer: PropTypes.func,
    badge: badgePropType,
    anchorEl: PropTypes.any,
  };

  static defaultProps = {
    blockName: 'm-global-header-icon',
  };

  renderIcon = () => {
    const { blockName, icon, customIconClass, badge, iconRenderer, isPopoverOpen, popoverBody, anchorEl } =
      this.props;

    return iconRenderer ? (
      iconRenderer()
    ) : (
      <div className={`${blockName}__icon m-global-header__icon-wrapper`}>
        <img className={customIconClass} src={icon} />
        {badge && this.renderBadge()}
        {popoverBody && anchorEl && (
          <Popover
            className={`${blockName}__popover-body`}
            open={isPopoverOpen}
            anchorEl={anchorEl}
            anchorOrigin={defaultAnchorOrigin}
            transformOrigin={defaultTransformOrigin}
          >
            {popoverBody}
          </Popover>
        )}
      </div>
    );
  };

  renderBadge = () => {
    const {
      blockName,
      badge: { body },
    } = this.props;

    return <div className={`${blockName}__badge`}>{body}</div>;
  };

  render() {
    const { blockName, className } = this.props;
    const finalClassName = cx(blockName, className);

    return <div className={finalClassName}>{this.renderIcon()}</div>;
  }
}

export default HeaderIcon;
